import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(theme => ({
  avatar: {
    borderRadius: theme.spacing(0.5, 0, 0, 0.5),
    margin: theme.spacing(-1.5, 2, -1.5, -2)
  },
  alert: {
    margin: '0 auto',
    maxWidth: `924px !important`,
    padding: `12px 16px !important`,
    position: 'fixed',
    zIndex: 1,
    bottom: theme.spacing(12),
    left: 0,
    right: 0
  },
  successAlert: {
    position: 'static',
    transform: 'translateY(-30px) !important'
  },
  errorAlert: {
    paddingRight: theme.spacing(2)
  },
  button: {
    whiteSpace: 'nowrap',
    marginRight: theme.spacing(4)
  }
}));
